// extracted by mini-css-extract-plugin
export var attachmentContainer = "_lm-0";
export var fileList = "_lm-2";
export var removeFileButton = "_lm-1";